import React from 'react';
import UiWidgetText from './UiWidgetText';
import UiWidgetTitle from './UiWidgetTitle';
import UiWidgetLink from './UiWidgetLink';
import UiWidgetImage from './UiWidgetImage';
import UiWidgetSeparator from './UiWidgetSeparator';
import UiWidgetRow from './UiWidgetRow';
import UiWidgetPlainText from './UiWidgetPlainText';
import UiWidgetIframe from './UiWidgetIframe';
import UiWidgetEmptyRow from './UiWidgetEmptyRow';
import UiWidgetDropdown from './UiWidgetDropdown';
import UiWidgetLoop from './UiWidgetLoop';
import type {
	DataSourceSettings,
	WidgetCommonProps,
	WidgetDataSourceProps
} from '../hooks/integrations/externalIntegrationTypes';
import { UiWidgetDropdownOption } from './UiWidgetDropdownOption';
import UiWidgetConditional from './UiWidgetConditional';
import UiWidgetDate from './UiWidgetDate';
import UiWidgetButton from './UiWidgetButton';
import UiWidgetRunOnChange from './UiWidgetRunOnChange';
import type { Order } from 'App/resources/Model/Order';

type FieldActions = {
	updated?: {
		order: Partial<Order>;
	};
	disabled?: {
		order: { [key: string]: boolean | FieldActions };
	};
	visible?: {
		order: { [key: string]: boolean | FieldActions };
	};
};

const UiWidgetComponent = ({
	row,
	widgetExternalId,
	dataSources,
	widgetSettings,
	widgetType,
	onClick,
	updateOrderFromApp,
	dataSourceSettings
}: {
	row: any;
	widgetExternalId: string;
	dataSources?: any;
	widgetSettings?: any;
	widgetType?: string;
	onClick?: (clickAction: string, clickSettings: Record<string, any>) => void;
	updateOrderFromApp?: (fieldActions: FieldActions, order?: Order) => void;
	dataSourceSettings?: DataSourceSettings;
}) => {
	const commonProps: WidgetCommonProps = {
		row,
		widgetExternalId,
		widgetType
	};

	const dataSourceProps: WidgetDataSourceProps = {
		...commonProps,
		dataSources,
		widgetSettings,
		dataSourceSettings
	};

	switch (row.type) {
		case 'Text':
			return <UiWidgetText {...dataSourceProps} />;
		case 'Button':
			return <UiWidgetButton {...dataSourceProps} updateOrderFromApp={updateOrderFromApp} />;
		case 'RunOnChange':
			return <UiWidgetRunOnChange {...dataSourceProps} updateOrderFromApp={updateOrderFromApp} />;
		case 'Title':
			return <UiWidgetTitle {...dataSourceProps} />;
		case 'Link':
			return <UiWidgetLink {...dataSourceProps} />;
		case 'Image':
			return <UiWidgetImage {...commonProps} />;
		case 'Separator':
			return <UiWidgetSeparator {...commonProps} />;
		case 'Row':
			return <UiWidgetRow {...dataSourceProps} />;
		case 'PlainText':
			return <UiWidgetPlainText {...dataSourceProps} />;
		case 'Iframe':
			return <UiWidgetIframe {...commonProps} />;
		case 'EmptyRow':
			return <UiWidgetEmptyRow {...commonProps} />;
		case 'Dropdown':
			return <UiWidgetDropdown {...dataSourceProps} />;
		case 'DropdownOption':
			return <UiWidgetDropdownOption {...dataSourceProps} onClick={onClick} />;
		case 'Loop':
			return <UiWidgetLoop {...dataSourceProps} />;
		case 'Conditional':
			return <UiWidgetConditional {...dataSourceProps} />;
		case 'Date':
			return <UiWidgetDate {...dataSourceProps} />;
		default:
			// Fallback for unknown types
			return <div className="UiWidget__unknown">{row.settings?.text || `Unknown row type: ${row.type}`}</div>;
	}
};

export default UiWidgetComponent;
